
import { createContext } from "react";
import { Session, User } from "@supabase/supabase-js";
import { Profile } from "@/hooks/auth/profile/types";

export type AuthContextType = {
  session: Session | null;
  user: User | null;
  profile: Profile | null;
  isLoading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (formData: any) => Promise<{ error: any | null }>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<boolean>;
};

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
